<script setup>
import { useLayout } from '@/layout/composables/layout';
import { useSidebarStore } from '@/store/sidebar-store';
import { onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const { layoutState, setActiveMenuItem, onMenuToggle } = useLayout();
const sidebarStore = useSidebarStore();

const props = defineProps({
    item: {
        type: Object,
        default: () => ({})
    },
    index: {
        type: Number,
        default: 0
    },
    root: {
        type: Boolean,
        default: true
    },
    parentItemKey: {
        type: String,
        default: null
    }
});

const isActiveMenu = ref(false);
const itemKey = ref(null);

onBeforeMount(() => {
    itemKey.value = props.parentItemKey ? props.parentItemKey + '-' + props.index : String(props.index);

    const activeItem = layoutState.activeMenuItem;

    isActiveMenu.value = activeItem === itemKey.value || activeItem ? activeItem.startsWith(itemKey.value + '-') : false;
});

watch(
    () => layoutState.activeMenuItem,
    (newVal) => {
        isActiveMenu.value = newVal === itemKey.value || newVal.startsWith(itemKey.value + '-');
    }
);
const itemClick = (event, item) => {
    if (item.disabled) {
        event.preventDefault();
        return;
    }

    if ((item.to || item.url) && (layoutState.staticMenuMobileActive || layoutState.overlayMenuActive)) {
        onMenuToggle();
    }

    if (item.command) {
        item.command({ originalEvent: event, item: item });
    }

    // 모바일 + 페이지 이동 시에만 사이드바 닫기
    if (window.innerWidth < 768 && item.to) {
        sidebarStore.setSidebarState(false);
    }

    const foundItemKey = item.items ? (isActiveMenu.value ? props.parentItemKey : itemKey) : itemKey.value;

    setActiveMenuItem(foundItemKey);
};

const checkActiveRoute = (item) => {
    return route.path === item.to;
};

const emit = defineEmits(['click']);
const handleClick = (event, item) => {
    emit('click', item);
    itemClick(event, item);
};
</script>

<template>
    <li :class="{ 'layout-root-menuitem': root, 'active-menuitem': isActiveMenu, redtest: isActiveMenu }">
        <div v-if="root && item.visible !== false" class="layout-menuitem-root-text">{{ item.label }}</div>
        <a v-if="(!item.to || item.items) && item.visible !== false" :href="item.url" @click="handleClick($event, item)" :class="item.class" :target="item.target" tabindex="0">
            <!-- <i :class="[isActiveMenu ? item.icon + (item.tag === 'lv1' ? '-active' : '-open') : item.icon]" class="layout-menuitem-icon"></i> -->
            <i :class="[item.tag === 'folder' ? (isActiveMenu ? item.icon + (item.tag === 'folder' ? '-open' : '') : item.icon) : item.icon]" class="layout-menuitem-icon"></i>
            <!-- 메뉴바 상위 TEXT -->
            <span class="layout-menuitem-text">{{ item.label }}</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" v-if="item.items"></i>
        </a>
        <router-link v-if="item.to && !item.items && item.visible !== false" @click="itemClick($event, item, index)" :class="[item.class, { 'active-route': checkActiveRoute(item) }, '123456789']" tabindex="0" :to="item.to">
            <i :class="item.icon" class="layout-menuitem-icon"></i>
            <!-- 메뉴바 상위 TEXT -->
            <span class="layout-menuitem-text">{{ item.label }} </span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" v-if="item.items"></i>
        </router-link>
        <Transition v-if="item.items && item.visible !== false" name="layout-submenu">
            <ul v-show="root ? true : isActiveMenu" class="layout-submenu">
                <app-menu-item v-for="(child, i) in item.items" :key="child" :index="i" :item="child" :parentItemKey="itemKey" :root="false"></app-menu-item>
            </ul>
        </Transition>
    </li>
</template>

<style scoped>
/* 1뎁스 */
.layout-root-menuitem > .layout-submenu > li > a > .layout-menuitem-text,
.layout-root-menuitem > .layout-submenu > li > a > .layout-menuitem-icon {
    color: #6a6a6a;
    font-size: 1.08rem;
}

.layout-root-menuitem > .layout-submenu > li > a:hover > .layout-menuitem-text,
.layout-root-menuitem > .layout-submenu > li > a:hover > .layout-menuitem-icon {
    color: #0038ea;
}

/* 2, 3뎁스 */
.layout-submenu .layout-submenu > li > a > .layout-menuitem-text,
.layout-submenu .layout-submenu > li > a > .layout-menuitem-icon {
    color: #43444d;
    font-size: 1.08rem;
}

.layout-submenu .layout-submenu > li > a:hover > .layout-menuitem-text,
.layout-submenu .layout-submenu > li > a:hover > .layout-menuitem-icon {
    color: #0038ea;
}

.layout-submenu .layout-submenu > li > a.active-route > .layout-menuitem-text,
.layout-submenu .layout-submenu > li > a.active-route > .layout-menuitem-icon {
    color: #0038ea;
}
</style>
